// extracted by mini-css-extract-plugin
export default {"payment-detail-container":"PaymentDetailsGrid_payment-detail-container__NWmOO","item-container":"PaymentDetailsGrid_item-container__4fSR6"};